import React, { useState, useEffect } from 'react';
import { Country } from 'country-state-city';

const CountryDropdown = ({ onCountryChange, countryReset }) => {
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');

    useEffect(() => {
        const countryList = Country.getAllCountries();
        const sortedCountryList = countryList.sort((a, b) => a.name.localeCompare(b.name));
        setCountries(sortedCountryList);
    }, []);

    const handleCountryChange = (event) => {
        const selectedCountry = countries.find(country => country?.isoCode === event.target.value);
        setSelectedCountry(selectedCountry?.isoCode);
        onCountryChange(selectedCountry?.name);
    };

    useEffect(() => {
        setSelectedCountry('')
    }, [countryReset])

    return (
        <>
            <select id="selectCountry" className="form-select" value={selectedCountry} onChange={handleCountryChange}>
                <option value="">Select Country</option>
                {countries.map((country) => (
                    <option key={country.isoCode} value={country.isoCode}>
                        {country.name}
                    </option>
                ))}
            </select>
        </>

    );
};

export default CountryDropdown;
